import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  badge: {
    height: 'auto !important',
    fontSize: 12,
    padding: '0 8px',
  },
  nickName: {
    fontSize: '14px !important',
    color: colors.neutral900,
    lineHeight: '20px',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflow: 'hidden',
    wordBreak: 'break-word',
    fontWeight: 600,
  },
  fullName: {
    fontSize: 14,
    color: colors.neutral600,
    display: 'block',
    textOverflow: 'ellipsis',
  },
  pastDue: {
    color: '#DC2626',
  },
  onlinePresenceIndicator: {
    position: 'absolute',
    width: 15,
    height: 15,
    backgroundColor: '#F9911D',
    border: '3px solid white',
    borderRadius: '50%',
    marginLeft: 28,
    marginTop: 23,
  },
  dueTomorrow: {
    color: '#D97706',
  },
  dueToday: {
    color: '#B80261',
  },
});
